import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './store/slices/alumnos/index.js'; // Asegúrate de tener reducers definidos

export const store = configureStore({
  reducer: rootReducer,
});
